import React from 'react';
import { useProduct, ProductId, PRODUCT_NAMES } from '../../context/ProductContext';

interface ProductRouteProps {
  product: ProductId;
  children: React.ReactNode;
}

/**
 * A screen that belongs to a product. The account must hold that product.
 * It renders inside whichever shell is already open, so an add-on (Amplify
 * inside TinyCMS, TinySocial inside TinyCMS) does not switch the menu.
 */
export const ProductRoute: React.FC<ProductRouteProps> = ({ product, children }) => {
  const { entitled, isLoading } = useProduct();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen text-white">Loading...</div>
    );
  }

  if (!entitled.includes(product)) {
    return <ProductNotIncluded product={product} />;
  }

  return <>{children}</>;
};

/** Shown when the account's plan does not include the product. */
const ProductNotIncluded: React.FC<{ product: ProductId }> = ({ product }) => (
  <div className="flex items-center justify-center min-h-screen bg-core-dark px-6">
    <div className="max-w-md text-center">
      <p className="text-xs uppercase tracking-widest text-cmp-ink-3 mb-3">Not included</p>
      <h1 className="text-2xl font-cmp-display font-normal text-cmp-ink mb-4">
        {PRODUCT_NAMES[product]} is not part of this account
      </h1>
      <p className="text-sm text-cmp-ink-2">
        Your plan does not include {PRODUCT_NAMES[product]}. An account administrator can add it —
        contact us to upgrade.
      </p>
    </div>
  </div>
);
